var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconsFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#socialIcons - Facebook__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .632a8 8 0 0 0-1.932 15.765v-5.32h-1.65V8.632h1.65V7.58c0-2.723 1.232-3.985 3.905-3.985.507 0 1.382.1 1.74.199V6.01c-.19-.02-.518-.03-.925-.03-1.312 0-1.818.497-1.818 1.789v.864h2.613l-.45 2.445H8.97v5.497A8 8 0 0 0 8 .632Z",
    fill: "#FCFCFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "socialIcons - Facebook__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .632)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconsFacebook);
export default __webpack_public_path__ + "static/media/socialIcons - Facebook.fdacf6ed18a3da05b21568c160fd09ee.svg";
export { ForwardRef as ReactComponent };